import React from 'react';
import { Head } from 'react-static';
import { useTranslation } from 'react-i18next';

import styled from 'styled-components';
import {
  H2, H3, P,
} from '../components/typo';
import { icons } from '../lib/icons';
import { Address, DescriptionWrap, PaddingWrap } from '../components/layout';
import { widthBp, sizes } from '../lib/styles';
import about from '../content/about';
import NextProject from '../components/NextProject';
import { ModalConsumer } from '../components/ModalProvider';

const Entry = styled.div`
  ${({ hasTitle }) => hasTitle && 'margin-top: 16px'};
`;

const SocialMediaWrap = styled.div`
  display: flex;
  align-items: center;
  margin: 8px 0;
  @media (${widthBp(sizes.handheld)}) {
    margin: 4px 0;
  }
`;

const SocialMediaHandle = styled(P)`
  margin-top: 0;
  margin-bottom: 0;
  margin-left: 4px;
`;

const ImageWrap = styled.figure`
  width: 250px;
  height: 250px;
  position: relative;
  flex-shrink: 0;
  margin-bottom: 30px;
`;

const Image = styled.img`
  height: auto;
  width: 100%;
  max-width: 250px;
  user-select: none;
`;

const FlexContainer = styled.section`
  display: flex;
  flex-direction: column;
  max-width: none !important;
  @media (${widthBp(sizes.handheld)}) {
    flex-direction: row;
  }
`;

const Label = styled.label`
  display: inline-block;
  font-size: 15px;
  font-weight: 700;
  font-style: normal;
  font-family: 'Roboto',sans-serif;
  color: black;
  @media (prefers-color-scheme: light) {
    color: black;
  }
  @media (prefers-color-scheme: dark) {
    color: white;
  }
  @media (${widthBp(sizes.laptop)}) {
    font-size: 16px;
  }
`;

const Column = styled(P)`
  column-count: 1;
  @media (${widthBp(sizes.handheld)}) {
    column-count: 2;
  }
  cite {
    display: inline-block;
    font-size: 15px;
    margin-top: 3px;
  }
`;

const About = () => {
  const { t, i18n } = useTranslation();
  return (
    <ModalConsumer>
      {({ isMenuOpen }) => (
        <PaddingWrap isMenuOpen={isMenuOpen}>
          <Head title={t('about.me.name')} />
          <DescriptionWrap>
            <H2>{t('about.title')}</H2>
          </DescriptionWrap>
          <FlexContainer>
            <ImageWrap>
              <Image src={about.me.imageUrl} alt={t('about.me.name')} />
            </ImageWrap>
            <Address>
              <P noTop>
                <a
                  href={`mailto:${t('legal.mail')}`}
                  tabIndex={isMenuOpen ? '-1' : '0'}
                  rel="noopener noreferrer"
                >
                  {t('legal.mail')}
                </a>
                <br />
                <SocialMediaWrap>
                  {icons.instagram}
                  <SocialMediaHandle>
                    <a
                      href={t('about.me.instagramLink')}
                      tabIndex={isMenuOpen ? '-1' : '0'}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t('about.me.socialMediaHandle')}
                    </a>
                  </SocialMediaHandle>
                </SocialMediaWrap>
                <a
                  href={t('about.me.buyLink')}
                  tabIndex={isMenuOpen ? '-1' : '0'}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('about.me.buy')}
                </a>
              </P>
            </Address>
          </FlexContainer>
          <DescriptionWrap>
            {<Column dangerouslySetInnerHTML={{ __html: `${t('about.me.intro')} \n${t('about.me.details')}` }} />}
          </DescriptionWrap>
          <DescriptionWrap>
            <H3>{t('about.shows.title')}</H3>
            {about.shows.map((show) => {
              const hasTitle = i18n.exists(`about.shows.${show}.title`);
              return (
                <Entry key={show} hasTitle={hasTitle}>
                  {hasTitle && <Label>{t(`about.shows.${show}.title`)}</Label>}
                  <P noTop>
                    <a
                      href={t(`about.shows.${show}.link`)}
                      tabIndex={isMenuOpen ? '-1' : '0'}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t(`about.shows.${show}.children`)}
                    </a>
                  </P>
                </Entry>
              );
            })}
          </DescriptionWrap>
          <DescriptionWrap noMArgin>
            <H3>{t('about.text.title')}</H3>
            {about.texts.map((text) => {
              const hasTitle = i18n.exists(`about.text.${text}.title`);
              return (
                <Entry key={text}>
                  {hasTitle && <Label>{t(`about.text.${text}.title`)}</Label>}
                  <P noTop>
                    <a
                      href={t(`about.text.${text}.link`)}
                      tabIndex={isMenuOpen ? '-1' : '0'}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t(`about.text.${text}.children`)}
                    </a>
                  </P>
                </Entry>
              );
            })}
          </DescriptionWrap>
          {/* <DescriptionWrap noMargin>
            <H3>{t('about.education.title')}</H3>
            {about.education.map(unviversity => (
              <Entry key={unviversity} hasTitle>
                <Label>{t(`about.education.${unviversity}.title`)}</Label>
                <P noTop>{t(`about.education.${unviversity}.children`)}</P>
              </Entry>
            ))}
          </DescriptionWrap> */}
          <NextProject
            to={about.nextPath}
            label={t('generic.back')}
          />
        </PaddingWrap>
      )}
    </ModalConsumer>
  );
};
export default About;
